import { defineMessages } from 'react-intl';

export default defineMessages({
  description:
    'Directly purchase this asset via these services. Please make sure you are eligible to use these services based on your {countryOfResidence} or other factors.',
  countryOfResidence: 'country of residence',
  or: 'Or',
});
